import { z } from 'zod'

/** Who signed in to connect an AI app: someone in an organization, or PixelSign staff. */
export const MCP_PRINCIPAL_KINDS = ['tenant_user', 'staff'] as const

export const mcpPrincipalKindSchema = z.enum(MCP_PRINCIPAL_KINDS)

export type McpPrincipalKind = z.infer<typeof mcpPrincipalKindSchema>

export const PRISMA_MCP_PRINCIPAL_KINDS = ['TENANT_USER', 'STAFF'] as const

export type PrismaMcpPrincipalKind = (typeof PRISMA_MCP_PRINCIPAL_KINDS)[number]

export const MCP_PRINCIPAL_KIND_FROM_PRISMA = {
  TENANT_USER: 'tenant_user',
  STAFF: 'staff',
} as const satisfies Record<PrismaMcpPrincipalKind, McpPrincipalKind>

export const MCP_PRINCIPAL_KIND_TO_PRISMA = {
  tenant_user: 'TENANT_USER',
  staff: 'STAFF',
} as const satisfies Record<McpPrincipalKind, PrismaMcpPrincipalKind>
